import { Pipe, PipeTransform } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

@Pipe({ name: 'toSelectOption' })
export class ToSelectOptionPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}
  transform(value: any, translationKey = '', inAlphabetic = false) {
    let options = Array.from(Object.values({ ...value }));
    // TODO nem mindig működik a fordítás
    const hasOther = options.findIndex((opt) => opt === 'OTHER') >= 0;
    let returnObject = inAlphabetic
      ? options
          .map((opt) => ({
            value: opt,
            name: this.translateService.instant(`${translationKey}${opt}`),
          }))
          .sort((a, b) => a.name.localeCompare(b.name))
      : options.map((opt) => ({
          value: opt,
          name: this.translateService.instant(`${translationKey}${opt}`),
        }));
    if (hasOther) {
      returnObject = returnObject.filter(
        (element) => element.value !== 'OTHER'
      );
      returnObject.push({ name: `${translationKey}OTHER`, value: 'OTHER' });
    }
    return returnObject;
  }
}
